import { newsItems } from '@/mocks/home/news';

export default function Home() {
  return (
    <div className="w-full">
      {/* ===== TOP画 - 完全に既存のまま、一切変更しない ===== */}
      <section className="relative min-h-screen w-full bg-[#1a3344] flex items-center justify-center overflow-hidden">
        <img
          src="https://static.readdy.ai/image/e23393d7838c8eef7d896bdb043cee76/e5e0bf1846591f1c02777f5048e60ef2.png"
          alt="僕の東京日記 - 絡繰綺譚"
          className="w-full h-auto object-contain md:max-h-screen md:w-auto md:h-auto"
          loading="eager"
        />
      </section>

      {/* ===== セクション1：企画紹介 ===== */}
      <section className="w-full bg-[#f7f2ec] py-20 md:py-36 px-5 md:px-8">
        <div className="max-w-3xl mx-auto text-center font-serif">

          {/* メイン見出し */}
          <h2 className="text-3xl md:text-4xl font-bold text-[#2c2416] tracking-wide leading-snug">
            KARAKURI PROJECT、<br className="sm:hidden" />始動。
          </h2>

          {/* 本文1 */}
          <p className="mt-12 md:mt-14 text-base md:text-lg text-[#3d3226] leading-loose">
            2023年11月、主宰・宇治川まさなりのもと、<br />
            F.entertainmentとして音楽劇を中心とした<br className="sm:hidden" />作品創りがスタートしました。
          </p>
          <p className="mt-7 text-base md:text-lg text-[#3d3226] leading-loose">
            そして、<br />
            絡繰綺譚 KARAKURI KITAN<br className="sm:hidden" />『僕の東京日記』を<br className="hidden sm:block" />第一弾に、<br className="sm:hidden" />宇治川まさなりの次なるフェーズとして、<br className="sm:hidden" />F.と共に新たな歩みを始めます。
          </p>

          {/* 区切り線 */}
          <div className="my-12 md:my-24 w-12 h-px bg-[#B08A57] mx-auto"></div>

          {/* 絡繰綺譚 ロゴ */}
          <img
            src="https://static.readdy.ai/image/e23393d7838c8eef7d896bdb043cee76/f40a6a1cfa10a1a3c464969f53ae03e3.png"
            alt="絡繰綺譚 KARAKURI KITAN"
            className="mx-auto w-[90%] max-w-[500px] h-auto object-contain"
            loading="eager"
          />

          {/* 本文2 */}
          <div className="mt-12 md:mt-14 max-w-2xl mx-auto">
            <p className="text-base md:text-lg text-[#3d3226] leading-loose">
              絡繰綺譚（からくりきたん）は、<br />
              日本演劇史に残る優れた戯曲を<br className="sm:hidden" />現代に継承し、<br className="hidden sm:block" />新たな世代へ<br className="sm:hidden" />届けることを目的として<br className="sm:hidden" />立ち上げられた企画です。
            </p>
            <p className="mt-7 text-base md:text-lg text-[#3d3226] leading-loose">
              第一弾は、<br className="sm:hidden" />演劇界を代表する劇作家・永井愛<br className="sm:hidden" />（二兎社）の<br className="hidden sm:block" />『僕の東京日記』<br className="sm:hidden" />（第31回紀伊國屋演劇賞受賞作）を<br className="sm:hidden" />上演します。
            </p>
            <p className="mt-7 text-base md:text-lg text-[#3d3226] leading-loose">
              演出は、<br className="sm:hidden" />俳優としても舞台を中心に活躍し、<br />
              次世代の視点で情熱的に物語を描く<br />
              片山浩憲（かたやま ひろのり）が<br className="sm:hidden" />務めます。
            </p>
          </div>
        </div>
      </section>

      {/* ===== 最新情報（NEWS） ===== */}
      <section className="w-full bg-[#EEE8DC] pb-20 md:pb-36 px-5 md:px-8">
        <div className="max-w-3xl mx-auto font-serif">

          {/* 区切り線 */}
          <div className="w-full h-px bg-[#B08A57]/30 mb-12 md:mb-24"></div>

          {/* 見出し */}
          <div className="text-center mb-10 md:mb-18">
            <p className="text-xs md:text-sm text-[#B08A57] tracking-[0.3em]">
              NEWS
            </p>
            <div className="mt-1.5 mx-auto w-12 md:w-14 h-px bg-[#8A2635]/70"></div>
            <div className="mt-4 flex items-center justify-center gap-2 md:gap-3">
              <span className="block w-3 md:w-4 h-px bg-[#B08A57]"></span>
              <span className="block w-1 h-3 md:w-1.5 md:h-4 bg-[#8A2635]/60 rounded-sm shrink-0"></span>
              <h2 className="text-2xl md:text-3xl font-bold text-[#2c2416] tracking-wide">
                最新情報
              </h2>
              <span className="block w-1 h-3 md:w-1.5 md:h-4 bg-[#8A2635]/60 rounded-sm shrink-0"></span>
              <span className="block w-3 md:w-4 h-px bg-[#B08A57]"></span>
            </div>
          </div>

          {/* お知らせ一覧 */}
          <div className="max-w-2xl mx-auto">
            <ul className="border-t border-[#d4c5b0]">
              {newsItems.map((item) => (
                <li key={`${item.date}-${item.title}`} className="border-b border-[#d4c5b0] py-5">
                  <div className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-8">
                    <time className="text-sm md:text-base font-medium text-[#8b7355] sm:w-32 md:w-40 shrink-0 whitespace-nowrap">
                      {item.date}
                    </time>
                    {item.link ? (
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-base md:text-lg text-[#2c2416] leading-relaxed hover:text-[#9c3a3a] transition-colors"
                      >
                        {item.title}
                      </a>
                    ) : (
                      <span className="text-base md:text-lg text-[#2c2416] leading-relaxed">
                        {item.title}
                      </span>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* ===== セクション2：公演概要 ===== */}
      <section className="w-full bg-[#EEE8DC] pb-20 md:pb-36 px-5 md:px-8">
        <div className="max-w-3xl mx-auto font-serif">

          {/* 区切り線 */}
          <div className="w-full h-px bg-[#B08A57]/30 mb-12 md:mb-24"></div>

          {/* 見出し */}
          <div className="text-center mb-10 md:mb-18">
            <p className="text-xs md:text-sm text-[#B08A57] tracking-[0.3em]">
              INFORMATION
            </p>
            <div className="mt-1.5 mx-auto w-12 md:w-14 h-px bg-[#8A2635]/70"></div>
            <div className="mt-4 flex items-center justify-center gap-2 md:gap-3">
              <span className="block w-3 md:w-4 h-px bg-[#B08A57]"></span>
              <span className="block w-1 h-3 md:w-1.5 md:h-4 bg-[#8A2635]/60 rounded-sm shrink-0"></span>
              <h2 className="text-2xl md:text-3xl font-bold text-[#2c2416] tracking-wide">
                公演概要
              </h2>
              <span className="block w-1 h-3 md:w-1.5 md:h-4 bg-[#8A2635]/60 rounded-sm shrink-0"></span>
              <span className="block w-3 md:w-4 h-px bg-[#B08A57]"></span>
            </div>
          </div>

          {/* 公演概要一覧 */}
          <dl className="border-t border-[#d4c5b0]">
            <div className="flex flex-col sm:flex-row py-5 border-b border-[#d4c5b0] gap-1 sm:gap-8">
              <dt className="text-sm md:text-base text-[#8b7355] font-medium sm:w-32 md:w-40 shrink-0 whitespace-nowrap">
                主催
              </dt>
              <dd className="text-base md:text-lg text-[#2c2416]">
                KARAKURI PROJECT
              </dd>
            </div>

            <div className="flex flex-col sm:flex-row py-5 border-b border-[#d4c5b0] gap-1 sm:gap-8">
              <dt className="text-sm md:text-base text-[#8b7355] font-medium sm:w-32 md:w-40 shrink-0 whitespace-nowrap">
                公演名
              </dt>
              <dd className="text-base md:text-lg text-[#2c2416]">
                僕の東京日記<br />
                <span className="text-sm md:text-base text-[#5c4f3d]">（第31回紀伊國屋演劇賞受賞作）</span>
              </dd>
            </div>

            <div className="flex flex-col sm:flex-row py-5 border-b border-[#d4c5b0] gap-1 sm:gap-8">
              <dt className="text-sm md:text-base text-[#8b7355] font-medium sm:w-32 md:w-40 shrink-0 whitespace-nowrap">
                脚本
              </dt>
              <dd className="text-base md:text-lg text-[#2c2416]">
                永井愛（二兎社）
              </dd>
            </div>

            <div className="flex flex-col sm:flex-row py-5 border-b border-[#d4c5b0] gap-1 sm:gap-8">
              <dt className="text-sm md:text-base text-[#8b7355] font-medium sm:w-32 md:w-40 shrink-0 whitespace-nowrap">
                演出
              </dt>
              <dd className="text-base md:text-lg text-[#2c2416]">
                片山浩憲
              </dd>
            </div>

            <div className="flex flex-col sm:flex-row py-5 border-b border-[#d4c5b0] gap-1 sm:gap-8">
              <dt className="text-sm md:text-base text-[#8b7355] font-medium sm:w-32 md:w-40 shrink-0 whitespace-nowrap">
                公演日程
              </dt>
              <dd className="text-base md:text-lg text-[#2c2416]">
                2026年10月30日（金）〜11月3日（火・祝）
              </dd>
            </div>

            <div className="flex flex-col sm:flex-row py-5 border-b border-[#d4c5b0] gap-1 sm:gap-8">
              <dt className="text-sm md:text-base text-[#8b7355] font-medium sm:w-32 md:w-40 shrink-0 whitespace-nowrap">
                劇場
              </dt>
              <dd className="text-base md:text-lg text-[#2c2416]">
                すみだパークシアター倉
              </dd>
            </div>

            <div className="flex flex-col sm:flex-row py-5 border-b border-[#d4c5b0] gap-1 sm:gap-8">
              <dt className="text-sm md:text-base text-[#8b7355] font-medium sm:w-32 md:w-40 shrink-0 whitespace-nowrap">
                企画・製作
              </dt>
              <dd className="text-base md:text-lg text-[#2c2416]">
                絡繰綺譚 KARAKURI KITAN
              </dd>
            </div>
          </dl>
        </div>
      </section>

      {/* ===== セクション3：特報・主演紹介・TICKET ===== */}
      <section className="w-full bg-[#f7f2ec] pb-20 md:pb-36 px-5 md:px-8">
        <div className="max-w-4xl mx-auto font-serif">

          {/* 区切り線 */}
          <div className="w-full h-px bg-[#B08A57]/25 mb-12 md:mb-24"></div>

          {/* 出演者紹介 見出し */}
          <div className="text-center mb-10 md:mb-20">
            <p className="text-xs md:text-sm text-[#B08A57] tracking-[0.3em]">
              CAST
            </p>
            <div className="mt-1.5 mx-auto w-12 md:w-14 h-px bg-[#8A2635]/70"></div>
            <div className="mt-4 flex items-center justify-center gap-2 md:gap-3">
              <span className="block w-3 md:w-4 h-px bg-[#B08A57]"></span>
              <span className="block w-1 h-3 md:w-1.5 md:h-4 bg-[#8A2635]/60 rounded-sm shrink-0"></span>
              <h2 className="text-2xl md:text-3xl font-bold text-[#2c2416] tracking-wide">
                出演者紹介
              </h2>
              <span className="block w-1 h-3 md:w-1.5 md:h-4 bg-[#8A2635]/60 rounded-sm shrink-0"></span>
              <span className="block w-3 md:w-4 h-px bg-[#B08A57]"></span>
            </div>
          </div>

          {/* 栞組 */}
          <div className="mb-20 md:mb-32">
            <div className="text-center mb-5 md:mb-8">
              <h3 className="flex items-center justify-center gap-3 md:gap-4 leading-none">
                <span className="text-3xl md:text-4xl font-bold text-[#8A2635] tracking-[0.15em]">栞組</span>
                <span className="text-xl md:text-2xl font-semibold text-[#8A2635] tracking-[0.1em]">（しおり）</span>
              </h3>
              <div className="mt-3 md:mt-4 mx-auto w-12 md:w-16 h-px bg-[#8A2635]/50"></div>
            </div>

            {/* 公演日時 */}
            <div className="mt-6 md:mt-8 mb-10 md:mb-[60px]">
              <p className="text-center text-[10px] md:text-[11px] tracking-[0.25em] text-[#8A2635] mb-2">SCHEDULE／公演日時</p>
              <div className="max-w-[280px] md:max-w-sm mx-auto border border-[#8A2635]/60 rounded-md bg-[#fffdf9] px-6 py-5">
                <div className="space-y-2.5">
                  <div className="flex items-center justify-between gap-4">
                    <span className="text-xs md:text-sm text-[#3d3226] whitespace-nowrap">10月30日（金）</span>
                    <span className="text-xs md:text-sm text-[#2c2416] font-medium">19:00</span>
                  </div>
                  <div className="flex items-center justify-between gap-4">
                    <span className="text-xs md:text-sm text-[#3d3226] whitespace-nowrap">10月31日（土）</span>
                    <span className="text-xs md:text-sm text-[#2c2416] font-medium">18:00</span>
                  </div>
                  <div className="flex items-center justify-between gap-4">
                    <span className="text-xs md:text-sm text-[#3d3226] whitespace-nowrap">11月1日（日）</span>
                    <span className="text-xs md:text-sm text-[#2c2416] font-medium">14:00</span>
                  </div>
                  <div className="flex items-center justify-between gap-4">
                    <span className="text-xs md:text-sm text-[#3d3226] whitespace-nowrap">11月3日（火・祝）</span>
                    <span className="text-xs md:text-sm text-[#2c2416] font-medium">12:00</span>
                  </div>
                </div>
              </div>

              {/* 注意書き */}
              <div className="mt-4 max-w-[280px] md:max-w-sm mx-auto text-left text-[11px] md:text-xs leading-relaxed text-[#5c4f3d]">
                <p>※最後のシーンのみに登場するヒッピー・ポッキー役は、燈組の赤松薫が演じます。</p>
              </div>
            </div>

            {/* 主演：山﨑玲央 */}
            <div className="max-w-2xl mx-auto mb-8 md:mb-12 text-center">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 items-center">
                <img
                  src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/b2e10c18-144e-4cf1-b517-f4ee74c4bf26_compressed_1.webp"
                  alt="山﨑玲央 - 原田満男役"
                  className="w-full max-w-[280px] sm:max-w-none mx-auto h-auto object-contain"
                  loading="lazy"
                />
                <img
                  src="https://static.readdy.ai/image/e23393d7838c8eef7d896bdb043cee76/2f845ab5bd433d931940b7fae7564ad1.jpeg"
                  alt="山﨑玲央 出演者コメント"
                  className="w-full max-w-[280px] sm:max-w-none mx-auto h-auto object-contain"
                  loading="lazy"
                />
              </div>
              <p className="text-sm text-[#8b7355] mt-4">原田 満男 役</p>
              <p className="text-lg md:text-xl font-bold text-[#2c2416] mt-1">山﨑 玲央</p>
              <button className="mt-3 bg-[#9c3a3a] text-white text-sm font-bold px-6 py-2.5 rounded-md whitespace-nowrap">チケット予約</button>
            </div>

            {/* 2〜15番：2列×7段 */}
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5 max-w-4xl mx-auto mb-8 md:mb-12">
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/ec7507b1-629d-4af8-9e77-33342fef84ac_compressed_2.webp" alt="綾野アリス - 原田淑子役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">原田 淑子 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">綾野アリス</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/e31c7a71-0fc2-4fcb-babd-a83ad2fd0d6f_compressed_3.webp" alt="茶谷英司朗 - 相良静雄役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">相良 静雄 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">茶谷 英司朗</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/ad45be25-1129-4263-90e2-19799e21b6f7_compressed_4.webp" alt="大里冬子 - 小淵敏子役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">小淵 敏子 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">大里 冬子</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/894020a8-3344-4b0f-bb14-2e6b9fcfd734_compressed_5.webp" alt="飯塚大夢 - 井出哲朗役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">井出 哲朗 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">飯塚大夢</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/f46497ef-3cde-45ad-b444-55b6981fcb82_compressed_6.webp" alt="土橋竜太 - 新見良弘役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">新見 良弘 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">土橋 竜太</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/8873318c-f679-441b-9518-fd337a3cc2d3_compressed_7.webp" alt="井戸川百花 - 青木光江役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">青木 光江 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">井戸川 百花</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/ef4f0e73-e761-4afc-9415-7162232690ab_compressed_8.webp" alt="倉田ヨーコ - 上村のり子役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">上村 のり子 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">倉田 ヨーコ</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/9947ba95-afea-4ced-9a95-d4cff2c74418_compressed_9.webp" alt="爽夢 - 須藤則夫役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">須藤 則夫 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">爽夢</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/bb306c6c-4970-4a22-8da7-0bf1d879e046_compressed_10.webp" alt="須藤慧 - 鶴岡昭役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">鶴岡 昭 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">須藤 慧</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/b952bc7f-3a75-46e8-9dd3-982fe2739b7e_compressed_11.webp" alt="内山希生 - 土橋郁代役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">土橋 郁代 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">内山 希生</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/111b6fde-4e93-487c-a0aa-4cb4f60be5b8_compressed_12.webp" alt="細川こなみ - ゲソ役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">ゲソ 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">細川 こなみ</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/81dfc4f6-9cc3-4f12-989f-ccc98394f313_compressed_13.webp" alt="長谷川早紀 - ユッケ役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">ユッケ 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">長谷川 早紀</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/61bfafec-ffe7-4512-9c75-6808fccd4f01_compressed_14.webp" alt="石川真彩 - 菊池陽子役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">菊池 陽子 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">石川 真彩</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/30a158ac-bb6a-41f8-9636-e4a14b11b680_compressed_15.webp" alt="朝井ゆらら - 福島睦美役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">福島 睦美 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">朝井 ゆらら</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
            </div>

            {/* 白柏寿大 */}
            <div className="max-w-2xl mx-auto text-center">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 items-center">
                <img
                  src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/7cdc139f-bad1-4367-a76d-37fd6f966d4e_compressed_16.webp"
                  alt="白柏寿大 - ピータン役"
                  className="w-full max-w-[280px] sm:max-w-none mx-auto h-auto object-contain"
                  loading="lazy"
                />
                <img
                  src="https://static.readdy.ai/image/e23393d7838c8eef7d896bdb043cee76/2a61ad867d23ca6b17fa6e0727d15157.jpeg"
                  alt="白柏寿大 出演者コメント"
                  className="w-full max-w-[280px] sm:max-w-none mx-auto h-auto object-contain"
                  loading="lazy"
                />
              </div>
              <p className="text-sm text-[#8b7355] mt-4">ピータン 役</p>
              <p className="text-lg md:text-xl font-bold text-[#2c2416] mt-1">白柏 寿大</p>
              <button className="mt-3 bg-[#9c3a3a] text-white text-sm font-bold px-6 py-2.5 rounded-md whitespace-nowrap">チケット予約</button>
            </div>
          </div>

          {/* 区切り線 */}
          <div className="w-full h-px bg-[#B08A57]/25 mb-16 md:mb-24"></div>

          {/* 燈組 */}
          <div className="mb-16 md:mb-24">
            <div className="text-center mb-5 md:mb-8">
              <h3 className="flex items-center justify-center gap-3 md:gap-4 leading-none">
                <span className="text-3xl md:text-4xl font-bold text-[#B08A57] tracking-[0.15em]">燈組</span>
                <span className="text-xl md:text-2xl font-semibold text-[#B08A57] tracking-[0.1em]">（あかり）</span>
              </h3>
              <div className="mt-3 md:mt-4 mx-auto w-12 md:w-16 h-px bg-[#B08A57]/50"></div>
            </div>

            {/* 公演日時 */}
            <div className="mt-6 md:mt-8 mb-10 md:mb-[60px]">
              <p className="text-center text-[10px] md:text-[11px] tracking-[0.25em] text-[#8A2635] mb-2">SCHEDULE／公演日時</p>
              <div className="max-w-[280px] md:max-w-sm mx-auto border border-[#8A2635]/60 rounded-md bg-[#fffdf9] px-6 py-5">
                <div className="space-y-2.5">
                  <div className="flex items-center justify-between gap-4">
                    <span className="text-xs md:text-sm text-[#3d3226] whitespace-nowrap">10月31日（土）</span>
                    <span className="text-xs md:text-sm text-[#2c2416] font-medium">14:00</span>
                  </div>
                  <div className="flex items-center justify-between gap-4">
                    <span className="text-xs md:text-sm text-[#3d3226] whitespace-nowrap">11月1日（日）</span>
                    <span className="text-xs md:text-sm text-[#2c2416] font-medium">18:00</span>
                  </div>
                  <div className="flex items-center justify-between gap-4">
                    <span className="text-xs md:text-sm text-[#3d3226] whitespace-nowrap">11月2日（月）</span>
                    <span className="text-xs md:text-sm text-[#2c2416] font-medium">19:00</span>
                  </div>
                  <div className="flex items-center justify-between gap-4">
                    <span className="text-xs md:text-sm text-[#3d3226] whitespace-nowrap">11月3日（火・祝）</span>
                    <span className="text-xs md:text-sm text-[#2c2416] font-medium">16:00</span>
                  </div>
                </div>
              </div>

              {/* 注意書き */}
              <div className="mt-4 max-w-[280px] md:max-w-sm mx-auto text-left text-[11px] md:text-xs leading-relaxed text-[#5c4f3d]">
                <p className="font-bold text-xs md:text-sm text-[#8A2635] mb-2">ご注意</p>
                <p className="mb-2">11月3日（火・祝）16:00公演は、母親・原田淑子役を栞組の綾野アリスが演じます。</p>
                <p>※最後のシーンのみに登場するヒッピー・ポッキー役は、栞組の細川こなみが演じます。</p>
              </div>
            </div>

            {/* 主演：登野城佑真 */}
            <div className="max-w-2xl mx-auto mb-8 md:mb-12 text-center">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 items-center">
                <img
                  src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/262c8d16-1c23-4daf-a124-2fa31db6bb75_compressed__1.webp"
                  alt="登野城佑真 - 原田満男役"
                  className="w-full max-w-[280px] sm:max-w-none mx-auto h-auto object-contain"
                  loading="lazy"
                />
                <img
                  src="https://static.readdy.ai/image/e23393d7838c8eef7d896bdb043cee76/3e54c9f04de4d753049d42c7be909b63.jpeg"
                  alt="登野城佑真 出演者コメント"
                  className="w-full max-w-[280px] sm:max-w-none mx-auto h-auto object-contain"
                  loading="lazy"
                />
              </div>
              <p className="text-sm text-[#8b7355] mt-4">原田 満男 役</p>
              <p className="text-lg md:text-xl font-bold text-[#2c2416] mt-1">登野城 佑真</p>
              <button className="mt-3 bg-[#9c3a3a] text-white text-sm font-bold px-6 py-2.5 rounded-md whitespace-nowrap">チケット予約</button>
            </div>

            {/* 2〜15番：2列×7段 */}
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5 max-w-4xl mx-auto mb-8 md:mb-12">
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/87bc2848-aee0-45d2-b4b6-0fad501e489a_compressed__2.webp" alt="たむらもとこ - 原田淑子役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">原田 淑子 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">たむら もとこ</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/298176eb-b898-4d9a-b9dd-01bdf1bac753_compressed__3.webp" alt="小川輝晃 - 相良静雄役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">相良 静雄 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">小川 輝晃</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/e8e6fca9-33f3-4c11-8f98-7dc9b74ced3e_compressed__4.webp" alt="石川美樹 - 小淵敏子役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">小淵 敏子 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">石川 美樹</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/ae88faec-88be-4746-9645-8119dc2abd14_compressed__5.webp" alt="楓菜々 - 青木光江役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">青木 光江 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">楓 菜々</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/ecd3e1df-9db4-47f1-bdcb-282f94f1776c_compressed__6.webp" alt="武田知大 - 新見良弘役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">新見 良弘 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">武田 知大</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/1c05c295-9b39-46e7-85fc-a2ba7ba4f912_compressed__7.webp" alt="石野さやか - 上村のり子役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">上村 のり子 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">石野 さやか</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/6d0c0a64-3782-4413-b711-494e9e2d5352_compressed__8.webp" alt="亀井市ん司 - 井出哲朗役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">井出 哲朗 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">亀井市ん司</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/df981e55-2676-429a-9499-b83790c8f332_compressed__9.webp" alt="和泉ユウリ - 福島睦美役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">福島 睦美 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">和泉ユウリ</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/c9a12384-7cb0-4812-99c8-a58f658ab08b_compressed_10_.webp" alt="松岡拓弥 - 鶴岡昭役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">鶴岡 昭 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">松岡 拓弥</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/43acd62a-6627-495c-a671-3790020ce691_compressed__11.webp" alt="清氷紬生 - 土橋郁代役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">土橋 郁代 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">清氷 紬生</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/6a1464de-9708-484c-b4d1-0b851fb2ea20_compressed__12.webp" alt="相澤友輝 - 須藤則夫役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">須藤 則夫 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">相澤 友輝</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/413ec0dc-3481-4ce2-9335-689952518026_compressed__13.webp" alt="赤松薫 - ゲソ役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">ゲソ 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">赤松 薫</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/7126fc31-836d-4acc-89e6-70c3de212429_compressed__14.webp" alt="村田和 - 菊池陽子役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">菊池 陽子 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">村田 和</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
              <div className="text-center">
                <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/026080e1-4589-4c83-a93b-979257d88921_compressed__15.webp" alt="香雪 - ユッケ役" className="w-full h-auto object-contain" loading="lazy" />
                <p className="text-xs md:text-sm text-[#8b7355] mt-2">ユッケ 役</p>
                <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">香雪</p>
                <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
              </div>
            </div>

            {/* 白柏寿大（独立段） */}
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5 max-w-4xl mx-auto mt-8 md:mt-12">
              <div className="col-span-2 md:col-span-1 md:col-start-2 text-center">
                <div className="w-1/2 mx-auto md:w-full">
                  <img src="https://storage.helloreaddy.io/project_files/12086ddf-43cb-4d59-b587-ea1a7993d7a5/6f105fb0-198e-4ad3-a0d7-a9ccbb7b6bff_compressed__16.webp" alt="白柏寿大 - ピータン役" className="w-full h-auto object-contain" loading="lazy" />
                  <p className="text-xs md:text-sm text-[#8b7355] mt-2">ピータン 役</p>
                  <p className="text-sm md:text-base font-bold text-[#2c2416] mt-1">白柏 寿大</p>
                  <button className="mt-2 bg-[#9c3a3a] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap">チケット予約</button>
                </div>
              </div>
            </div>
          </div>

          {/* TICKET セクション */}
          <div className="mt-16 md:mt-28">

            {/* 区切り線 */}
            <div className="w-full h-px bg-[#B08A57]/25 mb-16 md:mb-20"></div>

            <div className="text-center mb-10 md:mb-16">
              <p className="text-xs md:text-sm text-[#B08A57] tracking-[0.3em]">
                TICKET
              </p>
              <div className="mt-1.5 mx-auto w-12 md:w-14 h-px bg-[#8A2635]/70"></div>
            </div>

            {/* 第3弾チケット発売 ヘッダー */}
            <div className="text-center mb-8 md:mb-12">
              <p className="text-xl md:text-2xl font-bold text-[#8A2635] tracking-wide">第3弾チケット発売</p>
              <p className="mt-3 text-sm md:text-base font-bold text-[#2c2416]">2026年9月9日（水）12:30発売開始</p>
              <p className="mt-1 text-xs md:text-sm text-[#5c4f3d]">【こりっちサイトにて発売】</p>
            </div>

            {/* 券種カード */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {/* 応援席（土・日・祝日） */}
              <div className="rounded-lg border border-[#8A2635]/40 bg-white p-5 md:p-6 flex flex-col">
                <div className="flex items-start justify-between gap-2">
                  <h3 className="text-lg md:text-xl font-bold text-[#2c2416]">応援席</h3>
                  <span className="shrink-0 inline-block rounded-full bg-[#9c3a3a] text-white text-[10px] md:text-xs font-bold px-2.5 py-1 whitespace-nowrap">数量限定</span>
                </div>
                <p className="mt-1 text-xs md:text-sm text-[#8b7355]">土・日・祝日</p>
                <p className="mt-3 text-2xl md:text-3xl font-bold text-[#9c3a3a]">8,500円 <span className="text-xs md:text-sm font-normal text-[#5c4f3d]">（税込）</span></p>
                <ul className="mt-4 space-y-2 text-sm md:text-base text-[#3d3226]">
                  <li className="flex items-start gap-2"><span className="text-[#8A2635] shrink-0">・</span><span>前方1～3列目確約</span></li>
                  <li className="flex items-start gap-2"><span className="text-[#8A2635] shrink-0">・</span><span>チェキ券付（終演後撮影会）</span></li>
                  <li className="flex items-start gap-2"><span className="text-[#8A2635] shrink-0">・</span><span>サイン入りパンフレット付</span></li>
                </ul>
              </div>

              {/* 応援席（平日／金・月） */}
              <div className="rounded-lg border border-[#8A2635]/40 bg-white p-5 md:p-6 flex flex-col">
                <div className="flex items-start justify-between gap-2">
                  <h3 className="text-lg md:text-xl font-bold text-[#2c2416]">応援席</h3>
                  <span className="shrink-0 inline-block rounded-full bg-[#9c3a3a] text-white text-[10px] md:text-xs font-bold px-2.5 py-1 whitespace-nowrap">数量限定</span>
                </div>
                <p className="mt-1 text-xs md:text-sm text-[#8b7355]">平日／金・月</p>
                <p className="mt-3 text-2xl md:text-3xl font-bold text-[#9c3a3a]">8,000円 <span className="text-xs md:text-sm font-normal text-[#5c4f3d]">（税込）</span></p>
                <ul className="mt-4 space-y-2 text-sm md:text-base text-[#3d3226]">
                  <li className="flex items-start gap-2"><span className="text-[#8A2635] shrink-0">・</span><span>前方1～3列目確約</span></li>
                  <li className="flex items-start gap-2"><span className="text-[#8A2635] shrink-0">・</span><span>チェキ券付（終演後撮影会）</span></li>
                  <li className="flex items-start gap-2"><span className="text-[#8A2635] shrink-0">・</span><span>サイン入りパンフレット付</span></li>
                </ul>
              </div>

              {/* 先行S席【チェキ券付】 */}
              <div className="rounded-lg border border-[#B08A57]/40 bg-white p-5 md:p-6 flex flex-col">
                <div className="flex items-start justify-between gap-2">
                  <h3 className="text-lg md:text-xl font-bold text-[#2c2416]">S席</h3>
                  <span className="shrink-0 inline-block rounded-full bg-[#B08A57] text-white text-[10px] md:text-xs font-bold px-2.5 py-1 whitespace-nowrap">チェキ券付</span>
                </div>
                <div className="mt-3 space-y-1.5">
                  <p className="text-sm md:text-base text-[#3d3226]"><span className="text-xs md:text-sm text-[#8b7355]">土・日・祝日：</span><span className="font-bold text-[#9c3a3a] text-lg md:text-xl">7,500円</span><span className="text-xs md:text-sm text-[#5c4f3d]">（税込）</span></p>
                  <p className="text-sm md:text-base text-[#3d3226]"><span className="text-xs md:text-sm text-[#8b7355]">平日／金・月：</span><span className="font-bold text-[#9c3a3a] text-lg md:text-xl">7,000円</span><span className="text-xs md:text-sm text-[#5c4f3d]">（税込）</span></p>
                </div>
                <ul className="mt-4 space-y-2 text-sm md:text-base text-[#3d3226]">
                  <li className="flex items-start gap-2"><span className="text-[#B08A57] shrink-0">・</span><span>チェキ券付（終演後撮影会）</span></li>
                  <li className="flex items-start gap-2"><span className="text-[#B08A57] shrink-0">・</span><span>4列目以降のお座席</span></li>
                </ul>
              </div>

              {/* 先行S席【パンフレット付】 */}
              <div className="rounded-lg border border-[#B08A57]/40 bg-white p-5 md:p-6 flex flex-col">
                <div className="flex items-start justify-between gap-2">
                  <h3 className="text-lg md:text-xl font-bold text-[#2c2416]">S席</h3>
                  <span className="shrink-0 inline-block rounded-full bg-[#B08A57] text-white text-[10px] md:text-xs font-bold px-2.5 py-1 whitespace-nowrap">パンフレット付</span>
                </div>
                <div className="mt-3 space-y-1.5">
                  <p className="text-sm md:text-base text-[#3d3226]"><span className="text-xs md:text-sm text-[#8b7355]">土・日・祝日：</span><span className="font-bold text-[#9c3a3a] text-lg md:text-xl">7,000円</span><span className="text-xs md:text-sm text-[#5c4f3d]">（税込）</span></p>
                  <p className="text-sm md:text-base text-[#3d3226]"><span className="text-xs md:text-sm text-[#8b7355]">平日／金・月：</span><span className="font-bold text-[#9c3a3a] text-lg md:text-xl">6,500円</span><span className="text-xs md:text-sm text-[#5c4f3d]">（税込）</span></p>
                </div>
                <ul className="mt-4 space-y-2 text-sm md:text-base text-[#3d3226]">
                  <li className="flex items-start gap-2"><span className="text-[#B08A57] shrink-0">・</span><span>サイン入りパンフレット付</span></li>
                  <li className="flex items-start gap-2"><span className="text-[#B08A57] shrink-0">・</span><span>4列目以降のお座席</span></li>
                </ul>
              </div>

              {/* 一般席 */}
              <div className="rounded-lg border border-[#d4c5b0] bg-white p-5 md:p-6 flex flex-col">
                <h3 className="text-lg md:text-xl font-bold text-[#2c2416]">一般席</h3>
                <div className="mt-3 space-y-1.5">
                  <p className="text-sm md:text-base text-[#3d3226]"><span className="text-xs md:text-sm text-[#8b7355]">土・日・祝日：</span><span className="font-bold text-[#9c3a3a] text-lg md:text-xl">6,000円</span><span className="text-xs md:text-sm text-[#5c4f3d]">（税込）</span></p>
                  <p className="text-sm md:text-base text-[#3d3226]"><span className="text-xs md:text-sm text-[#8b7355]">平日／金・月：</span><span className="font-bold text-[#9c3a3a] text-lg md:text-xl">5,500円</span><span className="text-xs md:text-sm text-[#5c4f3d]">（税込）</span></p>
                </div>
              </div>
            </div>

            {/* 第3弾チケット購入者限定特典 */}
            <div className="mt-10 md:mt-14 rounded-lg border border-[#B08A57]/50 bg-[#fffdf9] p-6 md:p-8">
              <h3 className="text-lg md:text-xl font-bold text-[#8A2635] text-center">第3弾チケット購入者限定特典</h3>
              <div className="mt-5 text-center">
                <p className="text-sm md:text-base text-[#3d3226]">応援席・S席の【チェキ券付】をご購入のお客様限定！</p>
                <p className="mt-2 text-sm md:text-base text-[#3d3226]">追加チェキ券を、特別価格でご購入いただけます。</p>
                <div className="mt-6 flex flex-row flex-wrap items-center justify-center gap-x-3 gap-y-2 sm:gap-x-5">
                  <p className="text-sm md:text-lg text-[#3d3226] whitespace-nowrap">通常価格　<span className="line-through text-[#8b7355]">1,500円</span></p>
                  <span className="text-[#9c3a3a] text-base md:text-xl font-bold whitespace-nowrap">→</span>
                  <p className="text-sm md:text-lg text-[#3d3226] whitespace-nowrap">特別価格　<span className="font-bold text-[#9c3a3a] text-lg md:text-2xl">1,200円</span></p>
                </div>
                <div className="mt-6 space-y-1.5 text-xs md:text-sm text-[#5c4f3d]">
                  <p>※チケットお申込みの際に、備考欄に購入枚数をご記入ください。</p>
                  <p>※第3弾発売終了後は価格が上がります。</p>
                </div>
              </div>
            </div>


          </div>
        </div>
      </section>

      {/* ===== セクション4：タイムスケジュール ===== */}
      <section className="w-full bg-[#EEE8DC] pb-20 md:pb-36 px-5 md:px-8">
        <div className="max-w-3xl mx-auto font-serif">

          {/* 区切り線 */}
          <div className="w-full h-px bg-[#B08A57]/30 mb-12 md:mb-24"></div>

          {/* 見出し */}
          <div className="text-center mb-10 md:mb-18">
            <p className="text-xs md:text-sm text-[#B08A57] tracking-[0.3em]">
              SCHEDULE
            </p>
            <div className="mt-1.5 mx-auto w-12 md:w-14 h-px bg-[#8A2635]/70"></div>
            <div className="mt-4 flex items-center justify-center gap-2 md:gap-3">
              <span className="block w-3 md:w-4 h-px bg-[#B08A57]"></span>
              <span className="block w-1 h-3 md:w-1.5 md:h-4 bg-[#8A2635]/60 rounded-sm shrink-0"></span>
              <h2 className="text-2xl md:text-3xl font-bold text-[#2c2416] tracking-wide">
                タイムスケジュール
              </h2>
              <span className="block w-1 h-3 md:w-1.5 md:h-4 bg-[#8A2635]/60 rounded-sm shrink-0"></span>
              <span className="block w-3 md:w-4 h-px bg-[#B08A57]"></span>
            </div>
            <p className="mt-4 text-sm md:text-base text-[#5c4f3d]">
              2026年10月30日（金）〜11月3日（火・祝）
            </p>
          </div>

          {/* PC用テーブル */}
          <div className="hidden sm:block overflow-hidden">
            <table className="w-full text-base text-[#3d3226]">
              <thead>
                <tr className="border-b border-[#8b7355]">
                  <th className="text-left py-3 pr-4 font-bold text-[#2c2416] w-40">公演日</th>
                  <th className="text-left py-3 pr-4 font-bold text-[#2c2416] w-28">開演時間</th>
                  <th className="text-left py-3 font-bold text-[#2c2416]">出演組</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-[#d4c5b0]">
                  <td className="py-4 pr-4">10月30日（金）</td>
                  <td className="py-4 pr-4 font-bold text-[#2c2416]">19:00</td>
                  <td className="py-4 text-[#8A2635]">栞組（しおり）</td>
                </tr>
                <tr className="border-b border-[#d4c5b0]">
                  <td className="py-4 pr-4">10月31日（土）</td>
                  <td className="py-4 pr-4 font-bold text-[#2c2416]">14:00</td>
                  <td className="py-4 text-[#B08A57]">燈組（あかり）</td>
                </tr>
                <tr className="border-b border-[#d4c5b0]">
                  <td className="py-4 pr-4">10月31日（土）</td>
                  <td className="py-4 pr-4 font-bold text-[#2c2416]">18:00</td>
                  <td className="py-4 text-[#8A2635]">栞組（しおり）</td>
                </tr>
                <tr className="border-b border-[#d4c5b0]">
                  <td className="py-4 pr-4">11月1日（日）</td>
                  <td className="py-4 pr-4 font-bold text-[#2c2416]">14:00</td>
                  <td className="py-4 text-[#8A2635]">栞組（しおり）</td>
                </tr>
                <tr className="border-b border-[#d4c5b0]">
                  <td className="py-4 pr-4">11月1日（日）</td>
                  <td className="py-4 pr-4 font-bold text-[#2c2416]">18:00</td>
                  <td className="py-4 text-[#B08A57]">燈組（あかり）</td>
                </tr>
                <tr className="border-b border-[#d4c5b0]">
                  <td className="py-4 pr-4">11月2日（月）</td>
                  <td className="py-4 pr-4 font-bold text-[#2c2416]">19:00</td>
                  <td className="py-4 text-[#B08A57]">燈組（あかり）</td>
                </tr>
                <tr className="border-b border-[#d4c5b0]">
                  <td className="py-4 pr-4">11月3日（火・祝）</td>
                  <td className="py-4 pr-4 font-bold text-[#2c2416]">12:00</td>
                  <td className="py-4 text-[#8A2635]">栞組（しおり）</td>
                </tr>
                <tr className="border-b border-[#d4c5b0]">
                  <td className="py-4 pr-4">11月3日（火・祝）</td>
                  <td className="py-4 pr-4 font-bold text-[#2c2416]">16:00</td>
                  <td className="py-4 text-[#B08A57]">燈組（あかり）</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* スマホ用カード */}
          <div className="sm:hidden space-y-5">
            <div className="border-b border-[#d4c5b0] pb-5">
              <p className="text-[#2c2416] font-bold text-lg">10月30日（金）</p>
              <div className="mt-2">
                <span className="text-base font-bold text-[#2c2416]">19:00</span>
                <span className="ml-3 text-sm text-[#9c3a3a]">栞組（しおり）</span>
              </div>
            </div>
            <div className="border-b border-[#d4c5b0] pb-5">
              <p className="text-[#2c2416] font-bold text-lg">10月31日（土）</p>
              <div className="mt-2 space-y-1">
                <div>
                  <span className="text-base font-bold text-[#2c2416]">14:00</span>
                  <span className="ml-3 text-sm text-[#B08A57]">燈組（あかり）</span>
                </div>
                <div>
                  <span className="text-base font-bold text-[#2c2416]">18:00</span>
                  <span className="ml-3 text-sm text-[#8A2635]">栞組（しおり）</span>
                </div>
              </div>
            </div>
            <div className="border-b border-[#d4c5b0] pb-5">
              <p className="text-[#2c2416] font-bold text-lg">11月1日（日）</p>
              <div className="mt-2 space-y-1">
                <div>
                  <span className="text-base font-bold text-[#2c2416]">14:00</span>
                  <span className="ml-3 text-sm text-[#8A2635]">栞組（しおり）</span>
                </div>
                <div>
                  <span className="text-base font-bold text-[#2c2416]">18:00</span>
                  <span className="ml-3 text-sm text-[#B08A57]">燈組（あかり）</span>
                </div>
              </div>
            </div>
            <div className="border-b border-[#d4c5b0] pb-5">
              <p className="text-[#2c2416] font-bold text-lg">11月2日（月）</p>
              <div className="mt-2">
                <span className="text-base font-bold text-[#2c2416]">19:00</span>
                <span className="ml-3 text-sm text-[#b07030]">燈組（あかり）</span>
              </div>
            </div>
            <div className="border-b border-[#d4c5b0] pb-5">
              <p className="text-[#2c2416] font-bold text-lg">11月3日（火・祝）</p>
              <div className="mt-2 space-y-1">
                <div>
                  <span className="text-base font-bold text-[#2c2416]">12:00</span>
                  <span className="ml-3 text-sm text-[#8A2635]">栞組（しおり）</span>
                </div>
                <div>
                  <span className="text-base font-bold text-[#2c2416]">16:00</span>
                  <span className="ml-3 text-sm text-[#B08A57]">燈組（あかり）</span>
                </div>
              </div>
            </div>
          </div>

          {/* 注意事項 */}
          <div className="mt-8 md:mt-14 space-y-2 text-xs md:text-sm text-[#5c4f3d]">
            <p>※開場は、開演の30分前です。</p>
            <p>※各公演終了後、客席にて撮影会を行います。担当者が当日ご案内いたします。</p>
          </div>
        </div>
      </section>

      {/* ===== 主催チケットフォーム ===== */}
      <section className="w-full bg-[#f7f2ec] py-16 md:py-24 px-5 md:px-8">
        <div className="max-w-3xl mx-auto font-serif text-center">
          <div className="w-full h-px bg-[#B08A57]/25 mb-10 md:mb-14"></div>
          <p className="text-xs md:text-sm text-[#B08A57] tracking-[0.3em]">TICKET FORM</p>
          <h2 className="mt-2 text-2xl md:text-3xl font-bold text-[#2c2416] tracking-wide">主催チケットフォーム</h2>
          <span className="inline-block mt-8 md:mt-10 bg-[#bd8a8a] text-white text-lg md:text-xl font-bold rounded-md px-10 md:px-14 py-4 md:py-5 whitespace-nowrap cursor-default">
            主催チケット申込み
          </span>
          <p className="mt-3 text-xs md:text-sm text-[#8b7355]">2026年9月9日（水）12:30受付開始</p>
        </div>
      </section>

      {/* ===== セクション5：座席表 ===== */}
      <section className="w-full bg-[#f7f2ec] pb-20 md:pb-36 px-5 md:px-8">
        <div className="max-w-3xl mx-auto font-serif">

          {/* 区切り線 */}
          <div className="w-full h-px bg-[#B08A57]/25 mb-12 md:mb-24"></div>

          {/* 見出し */}
          <div className="text-center mb-10 md:mb-18">
            <p className="text-xs md:text-sm text-[#B08A57] tracking-[0.3em]">
              SEAT MAP
            </p>
            <div className="mt-1.5 mx-auto w-12 md:w-14 h-px bg-[#8A2635]/70"></div>
            <div className="mt-4 flex items-center justify-center gap-2 md:gap-3">
              <span className="block w-3 md:w-4 h-px bg-[#B08A57]"></span>
              <span className="block w-1 h-3 md:w-1.5 md:h-4 bg-[#8A2635]/60 rounded-sm shrink-0"></span>
              <h2 className="text-2xl md:text-3xl font-bold text-[#2c2416] tracking-wide">
                座席表
              </h2>
              <span className="block w-1 h-3 md:w-1.5 md:h-4 bg-[#8A2635]/60 rounded-sm shrink-0"></span>
              <span className="block w-3 md:w-4 h-px bg-[#B08A57]"></span>
            </div>
          </div>

          {/* 座席表画像（拡大可能） */}
          <a
            href="https://static.readdy.ai/image/e23393d7838c8eef7d896bdb043cee76/41776d031efe4229226253bfa04cabcf.png"
            target="_blank"
            rel="noopener noreferrer"
            className="block mx-auto max-w-[800px] relative"
          >
            <img
              src="https://static.readdy.ai/image/e23393d7838c8eef7d896bdb043cee76/41776d031efe4229226253bfa04cabcf.png"
              alt="座席表"
              className="w-full h-auto object-contain cursor-pointer"
              loading="lazy"
            />
          </a>
          <p className="mt-3 text-center text-xs text-[#8b7355]">※タップまたはクリックで拡大表示できます</p>

          {/* 座席説明 */}
          <div className="mt-10 md:mt-16 space-y-5">
            <div className="border-t border-[#d4c5b0] pt-6">
              <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-8">
                <h3 className="text-lg md:text-xl font-bold text-[#8A2635] sm:w-32 md:w-40 shrink-0 whitespace-nowrap">
                  先行応援席
                </h3>
                <p className="text-base md:text-lg text-[#3d3226]">A〜C行確約</p>
              </div>
            </div>
            <div className="border-t border-[#d4c5b0] py-6">
              <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-8">
                <h3 className="text-lg md:text-xl font-bold text-[#B08A57] sm:w-32 md:w-40 shrink-0 whitespace-nowrap">
                  先行S席
                </h3>
                <p className="text-base md:text-lg text-[#3d3226]">D〜F行のお座席</p>
              </div>
            </div>
            <div className="border-t border-b border-[#d4c5b0] py-6">
              <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-8">
                <h3 className="text-lg md:text-xl font-bold text-[#4E5D46] sm:w-32 md:w-40 shrink-0 whitespace-nowrap">
                  一般席
                </h3>
                <p className="text-base md:text-lg text-[#3d3226]">G〜I行のお座席</p>
              </div>
            </div>
          </div>
          <p className="mt-6 text-center text-sm md:text-base text-[#5c4f3d]">※座席は全席指定です。</p>
        </div>
      </section>

      {/* ===== セクション6：物語 ===== */}
      <section className="w-full bg-[#EEE8DC] pb-20 md:pb-36 px-5 md:px-8">
        <div className="max-w-3xl mx-auto font-serif">

          {/* 区切り線 */}
          <div className="w-full h-px bg-[#B08A57]/30 mb-12 md:mb-24"></div>

          {/* 見出し */}
          <div className="text-center mb-10 md:mb-18">
            <p className="text-xs md:text-sm text-[#B08A57] tracking-[0.3em]">
              STORY
            </p>
            <div className="mt-1.5 mx-auto w-12 md:w-14 h-px bg-[#8A2635]/70"></div>
            <div className="mt-4 flex items-center justify-center gap-2 md:gap-3">
              <span className="block w-3 md:w-4 h-px bg-[#B08A57]"></span>
              <span className="block w-1 h-3 md:w-1.5 md:h-4 bg-[#8A2635]/60 rounded-sm shrink-0"></span>
              <h2 className="text-2xl md:text-3xl font-bold text-[#2c2416] tracking-wide">
                物語
              </h2>
              <span className="block w-1 h-3 md:w-1.5 md:h-4 bg-[#8A2635]/60 rounded-sm shrink-0"></span>
              <span className="block w-3 md:w-4 h-px bg-[#B08A57]"></span>
            </div>
          </div>

          {/* 本文 */}
          <div className="max-w-2xl mx-auto text-left">
            <p className="text-lg md:text-xl font-bold text-[#8A2635] tracking-wide">
              1971年11月。
            </p>

            <p className="mt-5 text-base md:text-lg text-[#3d3226] leading-loose">
              お坊ちゃん大学生の原田満男は、阿佐ヶ谷に実家がありながら、高円寺の古びたアパート「春風荘」で下宿を始める。
            </p>

            <p className="mt-5 text-base md:text-lg text-[#3d3226] leading-loose">
              騒然たる大学紛争には参加しきれなかったが、親からの自立だけは固く決意し、一人暮らしをスタートさせたのだった。
            </p>

            <p className="mt-5 text-base md:text-lg text-[#3d3226] leading-loose">
              「春風荘」に住む住人は、売れない新劇女優、反戦おでん屋カップル、役所勤めのヒッピー、公認会計士志望の猫嫌い男、スーパーで働く猫好き女、やくざのようなクリーニング屋など、変わり者だらけ。
            </p>

            <p className="mt-5 text-base md:text-lg text-[#3d3226] leading-loose">
              晴れて独立したはずが、個性的な住人と、息子の世話を焼きたがる母親に振り回され、思い悩む日々は続く。
            </p>

            <p className="mt-5 text-base md:text-lg text-[#3d3226] leading-loose">
              そんなある日、満男は思いもよらない事件に巻き込まれて――！？
            </p>

            <p className="mt-5 text-base md:text-lg text-[#3d3226] leading-loose">
              終息へ向かう学生紛争の中で揺れ動く若者たちと、彼らを取り巻く大人たち。
            </p>

            <p className="mt-5 text-base md:text-lg text-[#3d3226] leading-loose">
              それぞれが自分の生き方を模索する、笑いあり、涙ありの青春群像劇。
            </p>
          </div>
        </div>
      </section>

      {/* ===== セクション7：登場人物 ===== */}
      <section className="w-full bg-[#f7f2ec] pb-20 md:pb-36 px-5 md:px-8">
        <div className="max-w-5xl mx-auto font-serif">

          {/* 区切り線 */}
          <div className="w-full h-px bg-[#B08A57]/25 mb-12 md:mb-24"></div>

          {/* 見出し */}
          <div className="text-center mb-10 md:mb-18">
            <p className="text-xs md:text-sm text-[#B08A57] tracking-[0.3em]">
              CHARACTERS
            </p>
            <div className="mt-1.5 mx-auto w-12 md:w-14 h-px bg-[#8A2635]/70"></div>
            <div className="mt-4 flex items-center justify-center gap-2 md:gap-3">
              <span className="block w-3 md:w-4 h-px bg-[#B08A57]"></span>
              <span className="block w-1 h-3 md:w-1.5 md:h-4 bg-[#8A2635]/60 rounded-sm shrink-0"></span>
              <h2 className="text-2xl md:text-3xl font-bold text-[#2c2416] tracking-wide">
                登場人物
              </h2>
              <span className="block w-1 h-3 md:w-1.5 md:h-4 bg-[#8A2635]/60 rounded-sm shrink-0"></span>
              <span className="block w-3 md:w-4 h-px bg-[#B08A57]"></span>
            </div>
          </div>

          {/* 登場人物一覧 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">

            <div className="rounded-lg border border-[#d4c5b0] bg-white p-6 md:p-7">
              <h3 className="text-xl md:text-2xl font-bold text-[#2c2416] whitespace-nowrap">原田満男</h3>
                <span className="mt-2 inline-block rounded-full px-3.5 py-1 text-xs font-bold tracking-wide text-white whitespace-nowrap bg-[#8A2635]">主人公・大学生</span>
              <p className="mt-4 text-sm md:text-base text-[#3d3226] leading-relaxed md:leading-loose">
                親からの自立を求め、実家近くの古いアパート「春風荘」で暮らし始める大学一年生。育ちの良いお坊ちゃんで、真面目だが世間知らず、不器用で周囲の空気に流されやすい。学生運動には共感しながらも飛び込む覚悟はなく、理想と現実の間で揺れ続けている。個性豊かな住人や母親、そして爆弾事件に振り回される中で、人間の矛盾や弱さに触れていく。1971年の東京を戸惑いながら見つめ、自分なりの生き方を探し始める、未完成で純粋な青年。
              </p>
            </div>

            <div className="rounded-lg border border-[#d4c5b0] bg-white p-6 md:p-7">
              <h3 className="text-xl md:text-2xl font-bold text-[#2c2416] whitespace-nowrap">原田淑子</h3>
                <span className="mt-2 inline-block rounded-full px-3.5 py-1 text-xs font-bold tracking-wide text-white whitespace-nowrap bg-[#A56570]">満男の母</span>
              <p className="mt-4 text-sm md:text-base text-[#3d3226] leading-relaxed md:leading-loose">
                満男を深く愛し、何かと世話を焼かずにはいられない、上品で行動力のある母親。息子の自立を心配しながらも、先回りして周囲に挨拶し、生活の隅々まで整えようとする。過保護で支配的に見える一方、春風荘の住人たちを偏見なく観察し、次第に受け入れていく。爆弾事件では、理念や体面よりも人命を優先し、息子に責任の本当の意味を突きつける。最後には自ら危険を引き受け、満男を守りながら現実的な解決へ導く、強さと愛情の人。
              </p>
            </div>

            <div className="rounded-lg border border-[#d4c5b0] bg-white p-6 md:p-7">
              <h3 className="text-xl md:text-2xl font-bold text-[#2c2416] whitespace-nowrap">小淵敏子</h3>
                <span className="mt-2 inline-block rounded-full px-3.5 py-1 text-xs font-bold tracking-wide text-white whitespace-nowrap bg-[#4E5D46]">春風荘の管理人</span>
              <p className="mt-4 text-sm md:text-base text-[#3d3226] leading-relaxed md:leading-loose">
                古びたアパート「春風荘」を切り盛りし、個性の強い住人たちを見守る世話好きな管理人。口は悪くても情が深く、食事や生活の面倒を見ながら、住人同士の揉め事を柔らかく収める。誰に対しても分け隔てがなく、奇妙な共同生活を日常として受け止める大きな包容力を持つ。青木の女優人生を心配し、自分も働きながら、皆が帰れる場所を必死に守り続けている。激動する1971年を生活者の目線で支え、物語に温かさと現実感を与える春風荘の中心人物。
              </p>
            </div>

            <div className="rounded-lg border border-[#d4c5b0] bg-white p-6 md:p-7">
              <h3 className="text-xl md:text-2xl font-bold text-[#2c2416] whitespace-nowrap">相良静雄</h3>
                <span className="mt-2 inline-block rounded-full px-3.5 py-1 text-xs font-bold tracking-wide text-white whitespace-nowrap bg-[#4E5D46]">春風荘の住人</span>
              <p className="mt-4 text-sm md:text-base text-[#3d3226] leading-relaxed md:leading-loose">
                クリーニング店で働きながら春風荘に住み着く、荒っぽい口調とチンピラ気質の青年。刺青や威勢のよい振る舞いで自分を大きく見せるが、実際は臆病で傷つきやすく純情。土橋に密かな思いを寄せ、猫の問題や新見との対立にも、乱暴ながら人情深く介入する。必要とされることに自分の価値を見いだし、格好よく振る舞おうとしては空回りしてしまう。強がりの裏に孤独と優しさを抱えた、可笑しさと切なさを併せ持つ愛すべき人物。
              </p>
            </div>

            <div className="rounded-lg border border-[#d4c5b0] bg-white p-6 md:p-7">
              <h3 className="text-xl md:text-2xl font-bold text-[#2c2416] whitespace-nowrap">青木光江</h3>
                <span className="mt-2 inline-block rounded-full px-3.5 py-1 text-xs font-bold tracking-wide text-white whitespace-nowrap bg-[#4E5D46]">春風荘の住人・女優</span>
              <p className="mt-4 text-sm md:text-base text-[#3d3226] leading-relaxed md:leading-loose">
                新劇の舞台に立つことを夢見ながら、生活のために夜の仕事もしている春風荘の住人。寝巻姿で食堂を歩き回るほど自由奔放で、気取らず率直、周囲の目にもあまり動じない。女優としての誇りを持つ一方、舞台の少ない現実と安定した収入との間で迷い続けている。小淵とは遠慮なく本音をぶつけ合える関係で、春風荘の日常を明るく軽やかにしている。夢を捨てきれないまま現実を生きる、1970年代の若い表現者のたくましさと哀愁を担う。
              </p>
            </div>

            <div className="rounded-lg border border-[#d4c5b0] bg-white p-6 md:p-7">
              <h3 className="text-xl md:text-2xl font-bold text-[#2c2416] whitespace-nowrap">ピータン</h3>
                <span className="mt-2 inline-block rounded-full px-3.5 py-1 text-xs font-bold tracking-wide text-white whitespace-nowrap bg-[#A07C4A]">共同体の中心人物</span>
              <p className="mt-4 text-sm md:text-base text-[#3d3226] leading-relaxed md:leading-loose">
                共同体「ピース・ゲリラ」の中心人物で、区役所に勤めながら新しい生活共同体を夢見る青年。ラブ＆ピース、自然食、自給自足を掲げ、既成の家族制度や男女関係から自由であろうとする。穏やかで楽天的だが、深刻な政治対立や人間関係の破綻にも正面から向き合おうとしない。仲間が去り資金を持ち逃げされても理想を捨てず、宮古島での共同生活を語り続ける。自由の可能性と同時に、ヒッピー文化の甘さや無責任さを体現する、憎めない理想主義者。
              </p>
            </div>

            <div className="rounded-lg border border-[#d4c5b0] bg-white p-6 md:p-7">
              <h3 className="text-xl md:text-2xl font-bold text-[#2c2416] whitespace-nowrap">ゲソ</h3>
                <span className="mt-2 inline-block rounded-full px-3.5 py-1 text-xs font-bold tracking-wide text-white whitespace-nowrap bg-[#A07C4A]">共同体の住人</span>
              <p className="mt-4 text-sm md:text-base text-[#3d3226] leading-relaxed md:leading-loose">
                共同体「ピース・ゲリラ」でピータン、ユッケと暮らす、奔放で人懐こい若い女性。愛情や性を独占せず、誰とでも自由につながろうとする共同体の価値観を軽やかに生きる。陽気で距離感が近く、周囲を巻き込みながら、その場の欲望や気分に素直に行動する。やがて共同体の通帳を持って姿を消し、掲げていた理想と個人の自由との矛盾を露呈させる。時代の解放感と危うさを同時に背負い、共同体崩壊のきっかけとなる象徴的な人物。
              </p>
            </div>

            <div className="rounded-lg border border-[#d4c5b0] bg-white p-6 md:p-7">
              <h3 className="text-xl md:text-2xl font-bold text-[#2c2416] whitespace-nowrap">ユッケ</h3>
                <span className="mt-2 inline-block rounded-full px-3.5 py-1 text-xs font-bold tracking-wide text-white whitespace-nowrap bg-[#A07C4A]">共同体の住人</span>
              <p className="mt-4 text-sm md:text-base text-[#3d3226] leading-relaxed md:leading-loose">
                共同体「ピース・ゲリラ」でピータン、ゲソと暮らし、宮古島での自給生活を夢見る若い女性。明るく無邪気で甘え上手だが、自由恋愛の理想の陰で、愛されたいという感情も抱えている。共同体の言葉を素直に信じ、農業や音楽に囲まれた新しい暮らしへ胸を躍らせている。しかし理想と現実、人間同士の嫉妬や不安の間で揺れ、やがて春風荘から姿を消していく。革命を思想ではなく暮らしとして選ぼうとした、純粋さと脆さを持つ青春の一人。
              </p>
            </div>

            <div className="rounded-lg border border-[#d4c5b0] bg-white p-6 md:p-7">
              <h3 className="text-xl md:text-2xl font-bold text-[#2c2416] whitespace-nowrap">ポッキー</h3>
                <span className="mt-2 inline-block rounded-full px-3.5 py-1 text-xs font-bold tracking-wide text-white whitespace-nowrap bg-[#A07C4A]">共同体の新メンバー</span>
              <p className="mt-4 text-sm md:text-base text-[#3d3226] leading-relaxed md:leading-loose">
                ゲソとユッケが去った後、新たに「ピース・ゲリラ」へ加わる、率直で現実的な若い女性。コミューン祭りでピータンと出会い、宮古島行きを期待して春風荘へやって来る。共同体への憧れを持ちながらも、ゲソの通帳持ち逃げを冷静に見抜き、甘い幻想には流されない。楽天的なピータンに苛立ちつつ、新しい仲間として崩れかけた共同体に入り込んでいく。理想が破綻しても別の誰かが加わるという、時代の運動の循環としたたかさを示す人物。
              </p>
            </div>

            <div className="rounded-lg border border-[#d4c5b0] bg-white p-6 md:p-7">
              <h3 className="text-xl md:text-2xl font-bold text-[#2c2416] whitespace-nowrap">井出哲朗</h3>
                <span className="mt-2 inline-block rounded-full px-3.5 py-1 text-xs font-bold tracking-wide text-white whitespace-nowrap bg-[#8A6B4F]">反戦おでん店主・活動家</span>
              <p className="mt-4 text-sm md:text-base text-[#3d3226] leading-relaxed md:leading-loose">
                屋台「反戦おでん」を営みながら政治運動に関わる、正義感と闘争心の強い青年。小市民性や権力への服従を激しく批判し、生活の場でも革命の論理を貫こうとする。しかし組織から爆弾運搬を命じられると、恐怖と重圧から頭痛や腹痛に襲われ、動けなくなる。恋人のり子にも強く当たりながら、思想から降りることも、仲間を裏切ることもできず苦しむ。勇ましい言葉と生身の弱さの落差を通して、過激化した学生運動の悲劇と滑稽さを体現する。
              </p>
            </div>

            <div className="rounded-lg border border-[#d4c5b0] bg-white p-6 md:p-7">
              <h3 className="text-xl md:text-2xl font-bold text-[#2c2416] whitespace-nowrap">上村のり子</h3>
                <span className="mt-2 inline-block rounded-full px-3.5 py-1 text-xs font-bold tracking-wide text-white whitespace-nowrap bg-[#8A6B4F]">井出の恋人</span>
              <p className="mt-4 text-sm md:text-base text-[#3d3226] leading-relaxed md:leading-loose">
                井出の恋人として同棲し、「反戦おでん」の屋台と彼の活動を現実面から支える若い女性。穏やかで控えめだが、井出の体調や迷いを誰より理解し、組織との板挟みに苦しんでいる。理念を語るより先に生活を動かす実務家で、爆弾事件では井出に代わって危険を背負おうとする。追い詰められるほど判断が揺れ、満男に爆弾を託すことで、彼を事件の渦中へ巻き込んでしまう。愛する人を守りたい思いと運動への責任の間で引き裂かれる、切実で人間的な存在。
              </p>
            </div>

            <div className="rounded-lg border border-[#d4c5b0] bg-white p-6 md:p-7">
              <h3 className="text-xl md:text-2xl font-bold text-[#2c2416] whitespace-nowrap">新見良弘</h3>
                <span className="mt-2 inline-block rounded-full px-3.5 py-1 text-xs font-bold tracking-wide text-white whitespace-nowrap bg-[#4E5D46]">春風荘の住人・会計士志望</span>
              <p className="mt-4 text-sm md:text-base text-[#3d3226] leading-relaxed md:leading-loose">
                公認会計士を目指して猛勉強を続ける、几帳面で神経質な春風荘の住人。立身出世への執念が強く、猫の鳴き声や住人の騒ぎを嫌い、生活を秩序立てようとする。猫に餌を与える土橋と激しく対立するが、その攻撃性の根には失敗への恐怖と劣等感がある。努力や成功者への憧れを支えに生き、教科書を焼かれたと思い込んでも試験に挑み続ける。不器用な孤独を抱えながら最後に合格をつかみ、執念の強さと人間の意外な底力を示す人物。
              </p>
            </div>

            <div className="rounded-lg border border-[#d4c5b0] bg-white p-6 md:p-7">
              <h3 className="text-xl md:text-2xl font-bold text-[#2c2416] whitespace-nowrap">土橋郁代</h3>
                <span className="mt-2 inline-block rounded-full px-3.5 py-1 text-xs font-bold tracking-wide text-white whitespace-nowrap bg-[#4E5D46]">春風荘の住人</span>
              <p className="mt-4 text-sm md:text-base text-[#3d3226] leading-relaxed md:leading-loose">
                スーパーマーケットで働きながら、春風荘の周囲に集まる野良猫をひたむきに世話する女性。口数が少なくおとなしく見えるが、猫への愛情と自分の信念には激しいほど頑固。猫を嫌う新見との対立を深める一方、密かに相良を慕い、思い切ってその気持ちを告白する。理解されない孤独が積み重なると感情が暴走し、新見の本を燃やそうとする危うさも見せる。優しさと狂気、純情と攻撃性が同居する、春風荘の人々の心の傷を映し出す人物。
              </p>
            </div>

            <div className="rounded-lg border border-[#d4c5b0] bg-white p-6 md:p-7">
              <h3 className="text-xl md:text-2xl font-bold text-[#2c2416] whitespace-nowrap">福島睦美</h3>
                <span className="mt-2 inline-block rounded-full px-3.5 py-1 text-xs font-bold tracking-wide text-white whitespace-nowrap bg-[#8A6B4F]">政治活動家</span>
              <p className="mt-4 text-sm md:text-base text-[#3d3226] leading-relaxed md:leading-loose">
                井出と同じ政治運動に身を置き、妥協を許さず闘争の継続を迫る、鋭く強硬な活動家。沖縄返還や反戦を自分の問題として捉え、ヒッピー的な自由や観光気分を厳しく批判する。思想と行動の一致を求めるあまり、体調を崩した井出の迷いさえ自己批判の対象にしてしまう。言葉には正当性がある一方、仲間の弱さを受け止める余裕を失い、組織の圧力を体現していく。時代の切迫感と運動の純粋さ、そして過激化が生む非情さを背負った人物。
              </p>
            </div>

            <div className="rounded-lg border border-[#d4c5b0] bg-white p-6 md:p-7">
              <h3 className="text-xl md:text-2xl font-bold text-[#2c2416] whitespace-nowrap">須藤則夫</h3>
                <span className="mt-2 inline-block rounded-full px-3.5 py-1 text-xs font-bold tracking-wide text-white whitespace-nowrap bg-[#8A6B4F]">政治活動家</span>
              <p className="mt-4 text-sm md:text-base text-[#3d3226] leading-relaxed md:leading-loose">
                井出や福島とともに政治運動へ参加する、組織の中では比較的穏健で人間味のある青年。福島の厳しい追及を抑えようとし、追い詰められた井出やのり子の事情にも理解を示す。誰の言い分もわかろうとするため決断力に欠け、強硬な流れを止めきれない弱さを持つ。仲間を気遣いながらも組織の論理から完全には離れられず、優しさと加担の間で揺れている。過激な時代の中で良心を残しつつ、結果的に流れに従ってしまう普通の若者を象徴する。
              </p>
            </div>

            <div className="rounded-lg border border-[#d4c5b0] bg-white p-6 md:p-7">
              <h3 className="text-xl md:text-2xl font-bold text-[#2c2416] whitespace-nowrap">鶴岡昭</h3>
                <span className="mt-2 inline-block rounded-full px-3.5 py-1 text-xs font-bold tracking-wide text-white whitespace-nowrap bg-[#A56570]">満男の友人・大学生</span>
              <p className="mt-4 text-sm md:text-base text-[#3d3226] leading-relaxed md:leading-loose">
                満男の大学の友人で、学生運動への未練と挫折を抱えながら時代を見つめる青年。冗談好きで調子がよく、ヒッピーの自由な男女関係にもすぐ夢中になる軽さを持つ。一方で政治への関心を捨てきれず、運動から逃げた満男を責めながら、自分の卑怯さにも苦しむ。満男が急に変わって遠くへ行くことを恐れ、乱暴な言葉の奥で友人を必死に引き戻そうとする。理想にも日常にも徹しきれない同世代の迷いを、友情とユーモアを通して表す人物。
              </p>
            </div>

            <div className="rounded-lg border border-[#d4c5b0] bg-white p-6 md:p-7">
              <h3 className="text-xl md:text-2xl font-bold text-[#2c2416] whitespace-nowrap">菊池陽子</h3>
                <span className="mt-2 inline-block rounded-full px-3.5 py-1 text-xs font-bold tracking-wide text-white whitespace-nowrap bg-[#A56570]">大学の仲間</span>
              <p className="mt-4 text-sm md:text-base text-[#3d3226] leading-relaxed md:leading-loose">
                満男と鶴岡の大学仲間で、二人の対立を見守りながら間をつなぐ、明るく感受性豊かな女性。好奇心が強く、ヒッピーの共同体や宮古島での暮らしにも素直に心を動かされる。政治運動には参加経験があるものの、思想に縛られず、生活や感情の実感を大切にしている。満男の変化を心配し、傷つく鶴岡を支えながら、張り詰めた男たちの議論を柔らかく受け止める。重い時代の空気の中に、若者らしい柔軟さと温かさをもたらす、青春群像の良心的な存在。
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* ===== セクション8：アクセス ===== */}
      <section className="w-full bg-[#EEE8DC] pb-20 md:pb-36 px-5 md:px-8">
        <div className="max-w-3xl mx-auto font-serif">

          {/* 区切り線 */}
          <div className="w-full h-px bg-[#B08A57]/30 mb-12 md:mb-24"></div>

          {/* 見出し */}
          <div className="text-center mb-10 md:mb-18">
            <p className="text-xs md:text-sm text-[#B08A57] tracking-[0.3em]">
              ACCESS
            </p>
            <div className="mt-1.5 mx-auto w-12 md:w-14 h-px bg-[#8A2635]/70"></div>
            <div className="mt-4 flex items-center justify-center gap-2 md:gap-3">
              <span className="block w-3 md:w-4 h-px bg-[#B08A57]"></span>
              <span className="block w-1 h-3 md:w-1.5 md:h-4 bg-[#8A2635]/60 rounded-sm shrink-0"></span>
              <h2 className="text-2xl md:text-3xl font-bold text-[#2c2416] tracking-wide">
                劇場・アクセス
              </h2>
              <span className="block w-1 h-3 md:w-1.5 md:h-4 bg-[#8A2635]/60 rounded-sm shrink-0"></span>
              <span className="block w-3 md:w-4 h-px bg-[#B08A57]"></span>
            </div>
          </div>

          {/* 劇場情報 */}
          <div className="text-center mb-8 md:mb-14">
            <p className="text-xl md:text-2xl font-bold text-[#2c2416]">すみだパークシアター倉</p>
            <div className="mt-4 text-sm md:text-base text-[#3d3226] leading-relaxed">
              <p>〒130-0003</p>
              <p>東京都墨田区横川1-1-10</p>
            </div>
            <p className="mt-3 text-xs md:text-sm text-[#5c4f3d]">※劇場入口は大横川親水公園側です。</p>
          </div>

          {/* 交通案内 */}
          <div className="border-t border-[#d4c5b0] pt-6 mb-8 md:mb-14">
            <h3 className="text-sm md:text-base font-bold text-[#2c2416] mb-4 text-center">交通案内</h3>
            <div className="space-y-3 text-sm md:text-base text-[#3d3226]">
              <div className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4">
                <span className="font-medium text-[#2c2416] sm:w-32 md:w-40 shrink-0">JR総武線</span>
                <span>錦糸町駅 北口より徒歩15分</span>
              </div>
              <div className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4">
                <span className="font-medium text-[#2c2416] sm:w-32 md:w-40 shrink-0">都営浅草線</span>
                <span>本所吾妻橋駅 A2出口より徒歩13分</span>
              </div>
              <div className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4">
                <span className="font-medium text-[#2c2416] sm:w-32 md:w-40 shrink-0">都営浅草線・京成線</span>
                <span>押上駅 A2出口より徒歩14分</span>
              </div>
              <div className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4">
                <span className="font-medium text-[#2c2416] sm:w-32 md:w-40 shrink-0">東京メトロ半蔵門線・東武線</span>
                <span>押上駅 B2出口より徒歩15分</span>
              </div>
              <div className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4">
                <span className="font-medium text-[#2c2416] sm:w-32 md:w-40 shrink-0">東武伊勢崎線</span>
                <span>とうきょうスカイツリー駅より徒歩12分</span>
              </div>
            </div>
          </div>

          {/* 注意事項 */}
          <div className="mb-8 md:mb-14 space-y-2 text-xs md:text-sm text-[#5c4f3d]">
            <p>※東京メトロ半蔵門線・東武線からは、押上駅A2出口へ出られません。</p>
            <p>※劇場専用の駐車場はありません。お車でお越しの場合は、近隣のコインパーキングをご利用ください。</p>
          </div>

          {/* Googleマップ */}
          <div className="mb-6">
            <div className="relative w-full overflow-hidden rounded-md" style={{ paddingBottom: '56.25%' }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.0!2d139.8085!3d35.7167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188fa0!2z44GZ44G544Gn44KP44O844Oh44O844K444Oe44O844K_5YCJ!5e0!3m2!1sja!2sjp!4v1"
                className="absolute inset-0 w-full h-full border-0"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="すみだパークシアター倉"
              />
            </div>
          </div>

          <div className="text-center">
            <a
              href="https://www.google.com/maps/search/?api=1&query=%E3%81%99%E3%81%BF%E3%81%A0%E3%83%91%E3%83%BC%E3%82%AF%E3%82%B7%E3%82%A2%E3%82%BF%E3%83%BC%E5%80%89"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#9c3a3a] text-white text-sm md:text-base font-medium rounded-md px-8 py-3.5 md:px-10 md:py-3.5 transition-colors hover:bg-[#8a3232] whitespace-nowrap"
            >
              Googleマップで開く
            </a>
          </div>
        </div>
      </section>

      {/* ===== セクション9：公式SNS ===== */}
      <section className="w-full bg-[#f7f2ec] pb-20 md:pb-36 px-5 md:px-8">
        <div className="max-w-3xl mx-auto font-serif">

          {/* 区切り線 */}
          <div className="w-full h-px bg-[#B08A57]/25 mb-12 md:mb-24"></div>

          {/* 見出し */}
          <div className="text-center mb-10 md:mb-18">
            <p className="text-xs md:text-sm text-[#B08A57] tracking-[0.3em]">
              OFFICIAL LINKS
            </p>
            <div className="mt-1.5 mx-auto w-12 md:w-14 h-px bg-[#8A2635]/70"></div>
            <div className="mt-4 flex items-center justify-center gap-2 md:gap-3">
              <span className="block w-3 md:w-4 h-px bg-[#B08A57]"></span>
              <span className="block w-1 h-3 md:w-1.5 md:h-4 bg-[#8A2635]/60 rounded-sm shrink-0"></span>
              <h2 className="text-2xl md:text-3xl font-bold text-[#2c2416] tracking-wide">
                公式SNS
              </h2>
              <span className="block w-1 h-3 md:w-1.5 md:h-4 bg-[#8A2635]/60 rounded-sm shrink-0"></span>
              <span className="block w-3 md:w-4 h-px bg-[#B08A57]"></span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row justify-center gap-5 md:gap-10">
            <a
              href="https://x.com/KARAKURIPROJECT"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center justify-center border border-[#B08A57]/40 bg-white rounded-md px-8 py-6 md:px-10 md:py-7 transition-colors hover:bg-[#f0ebe3]"
            >
              <span className="text-sm md:text-base font-bold text-[#2c2416]">KARAKURI PROJECT 公式X</span>
              <span className="mt-1 text-xs md:text-sm text-[#8b7355]">@KARAKURIPROJECT</span>
            </a>
            <a
              href="https://x.com/fdotworld"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center justify-center border border-[#B08A57]/40 bg-white rounded-md px-8 py-6 md:px-10 md:py-7 transition-colors hover:bg-[#f0ebe3]"
            >
              <span className="text-sm md:text-base font-bold text-[#2c2416]">F.entertainment 公式X</span>
              <span className="mt-1 text-xs md:text-sm text-[#8b7355]">@fdotworld</span>
            </a>
          </div>
        </div>
      </section>

      {/* ===== セクション10：お問い合わせ ===== */}
      <section className="w-full bg-[#EEE8DC] pb-20 md:pb-36 px-5 md:px-8">
        <div className="max-w-3xl mx-auto font-serif">

          {/* 区切り線 */}
          <div className="w-full h-px bg-[#B08A57]/30 mb-12 md:mb-24"></div>

          {/* 見出し */}
          <div className="text-center mb-10 md:mb-18">
            <p className="text-xs md:text-sm text-[#B08A57] tracking-[0.3em]">
              CONTACT
            </p>
            <div className="mt-1.5 mx-auto w-12 md:w-14 h-px bg-[#8A2635]/70"></div>
            <div className="mt-4 flex items-center justify-center gap-2 md:gap-3">
              <span className="block w-3 md:w-4 h-px bg-[#B08A57]"></span>
              <span className="block w-1 h-3 md:w-1.5 md:h-4 bg-[#8A2635]/60 rounded-sm shrink-0"></span>
              <h2 className="text-2xl md:text-3xl font-bold text-[#2c2416] tracking-wide">
                お問い合わせ
              </h2>
              <span className="block w-1 h-3 md:w-1.5 md:h-4 bg-[#8A2635]/60 rounded-sm shrink-0"></span>
              <span className="block w-3 md:w-4 h-px bg-[#B08A57]"></span>
            </div>
          </div>

          <div className="text-center">
            <p className="text-sm md:text-base text-[#3d3226]">公演に関するお問い合わせ</p>
            <a
              href="mailto:info@karakuri-stage.jp"
              className="inline-block mt-4 text-lg md:text-xl font-bold text-[#9c3a3a] hover:underline"
            >
              info@karakuri-stage.jp
            </a>
          </div>
        </div>
      </section>

      {/* ===== フッター ===== */}
      <footer className="w-full bg-[#1a3344] py-10 md:py-16 px-5 md:px-8">
        <div className="max-w-3xl mx-auto font-serif text-center">
          <div className="space-y-3 text-sm md:text-base text-[#c4a882]">
            <p>企画・製作　絡繰綺譚 KARAKURI KITAN</p>
            <p>主催　KARAKURI PROJECT</p>
          </div>
          <div className="mt-8 w-12 h-px bg-[#8b7355] mx-auto"></div>
          <p className="mt-6 text-xs md:text-sm text-[#8b7355]">
            © 2026 KARAKURI PROJECT. All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}